const overlay = document.querySelector('.overlay');
const header = document.querySelector('header');

if (header) {

    const megaMenuTabs = header.querySelectorAll('.mega-menu');

    megaMenuTabs.forEach(tab => {

        tab.addEventListener('mouseenter', () => {
            overlay.setAttribute('active', '');
            tab.setAttribute('open', '');
        });
        
        tab.addEventListener('mouseleave', () => {
            overlay.removeAttribute('active', '');
            tab.removeAttribute('open');
        });
    });

}